import { SagaIterator } from 'redux-saga'
import { call, fork, put, takeLatest } from 'redux-saga/effects'
import { SET_API_TOKEN } from '../../constants/apiConstants'
import {
  CHANGE_PASSWORD_ACTION,
  FORGOT_PASSWORD_ACTION,
  GET_IMAGE_URL,
  LOGIN_ACTION,
  UPDATE_USER_ACTION,
} from './actionTypes'
import {
  changePasswordData,
  getProfilePicture,
  postForgotPasswordData,
  postloginData,
  updateUserData,
} from './api'
import { errorAuth, setImageUrl, setUserData, successAuth } from './authReducer'
import {
  changePasswordType,
  forgotPasswordDataType,
  loginApiData,
  loginDataType,
  UserDataType,
} from './types'

type PostLoginActionType = {
  type: string
  payload: loginDataType
}

type PostForgotPasswordActionType = {
  type: string
  payload: forgotPasswordDataType
}

type UpdateUserActionType = {
  type: string
  payload: UserDataType
}

type changePasswordActionType = {
  type: string
  payload: changePasswordType
}

export function* handlePostLoginData(
  actions: PostLoginActionType
): SagaIterator<void> {
  try {
    const response = yield call(postloginData, actions.payload)
    const { data: apiData } = response
    const data = apiData as loginApiData
    SET_API_TOKEN(data.token)
    yield put(
      setUserData({
        title: data.title,
        firstName: data.firstName,
        lastName: data.lastName,
        jobTitle: data.jobTitle,
        phonePrimary: data.phonePrimary,
        phoneSecondary: data.phoneSecondary,
        hk: data.hk,
        uk: data.uk,
        hospitalName: data.hn,
        image: data.image,
      })
    )
    yield put(successAuth(data.status))
  } catch (error: any) {
    yield put(errorAuth(error.response.data.message))
  }
}

export function* handlePostForgotPasswordData(
  actions: PostForgotPasswordActionType
): SagaIterator<void> {
  try {
    const response = yield call(postForgotPasswordData, actions.payload)
    const { data } = response
    yield put(successAuth(data.message))
  } catch (error: any) {
    yield put(errorAuth(error.response.data.message))
  }
}

export function* handleUpdateUserData(
  actions: UpdateUserActionType
): SagaIterator<void> {
  try {
    const response = yield call(updateUserData, actions.payload)
    const { data } = response
    yield put(setUserData(actions.payload))
    yield put(successAuth(data.message))
  } catch (error: any) {
    yield put(errorAuth(error.response.data.message))
  }
}

export function* handleChangePasswordData(
  actions: changePasswordActionType
): SagaIterator<void> {
  try {
    const response = yield call(changePasswordData, actions.payload)
    const { data } = response
    yield put(successAuth(data.message))
  } catch (error: any) {
    yield put(errorAuth(error.response.data.message))
  }
}

type GetProfilePictureActionType = {
  type: string
  payload: string
}

export function* handleGetProfilePicture(
  actions: GetProfilePictureActionType
): SagaIterator<void> {
  try {
    const response = yield call(getProfilePicture, actions.payload)
    const imageUrl = URL.createObjectURL(response.data)
    yield put(setImageUrl(imageUrl))
  } catch (error: any) {}
}

export function* watcherSaga() {
  yield takeLatest(LOGIN_ACTION, handlePostLoginData)
  yield takeLatest(FORGOT_PASSWORD_ACTION, handlePostForgotPasswordData)
  yield takeLatest(UPDATE_USER_ACTION, handleUpdateUserData)
  yield takeLatest(CHANGE_PASSWORD_ACTION, handleChangePasswordData)
  yield takeLatest(GET_IMAGE_URL, handleGetProfilePicture)
}

export const authSaga = [fork(watcherSaga)]
